/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import styled from "styled-components";
import { Participant } from "types/Participant";

const ConnectivityCircle = styled.span<{ color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 6px;
  border: 2px solid white;
  background-color: ${(props): string => props.color};
`;

export const ParticipantConnectivityIndicator: React.FC<{
  participant: Participant;
}> = ({ participant }: { participant: Participant }) => {
  let color = "var(--spectrum-global-color-static-orange-500)";
  if (
    participant.webRtcConnectionState === "connected" &&
    participant.streamActive
  ) {
    color = "var(--spectrum-global-color-static-celery-800)";
  } else if (
    participant.webRtcConnectionState === "failed" ||
    participant.webRtcConnectionState === "disconnected"
  ) {
    color = "var(--spectrum-global-color-static-red-700)";
  }

  return (
    <ConnectivityCircle
      color={color}
      title={`WebRTC connection state: ${participant.webRtcConnectionState}, Stream active: ${participant.streamActive}`}
    />
  );
};
